import React from "react";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import TagButton from "../TagButton/TagButton";
import { useDispatch } from "react-redux";
import { getCoursesAsync } from "../../redux/coursesReducer";

import StarIcon from "../Icons/StarIcon";

const ListItem = ({
  title = "",
  thumbnail = "",
  cost,
  courseID = "",
  by = "",
  tags,
  rating,
}) => {
  const history = useHistory();
  const [showImage, setShowImage] = useState(false);

  const dispatch = useDispatch();

  return (
    <div className="transform transition-all duration-200 drop-shadow-lg shadow-2xl rounded-md flex flex-col content-center gap-6 relative p-5 ">
      <div className="md:col-span-2 col-span-1 overflow-hidden rounded-md h-36 relative flex justify-center items-center">
        {!showImage && (
          <div className="h-full w-full rounded-md cursor-pointer absolute gradient-loader" />
        )}

        <Link to={`/courses/course?courseID=${courseID}`}>
          <img
            src={`${thumbnail}`}
            className={`rounded-md cursor-pointer bg-cover z-10 ${
              showImage && "w-full"
            }`}
            alt=""
            loading="lazy"
            onLoad={() => thumbnail !== "" && setShowImage(true)}
          />
        </Link>
      </div>
      <div className="md:col-span-3 col-span-1 mt-2">
        <Link
          to={`/courses/course?courseID=${courseID}`}
          className="outline-none focus:text-indigo-500"
        >
          <h2 className="max-h-12 font-semibold text-black hover:text-indigo-400 duration-300 cursor-pointer truncate text-xl md:text-2xl">
            {title}
          </h2>
        </Link>

        {/* //cost */}
        <div className="relative">
          {cost !== undefined ? (
            <div className="grid grid-cols-2 gap-2">
              <h5
                className={`cursor-pointer mt-2 inline-block col-span-full truncate text-gray-700 font-normal`}
              >
                On {by}
              </h5>
              <h5 className="text-xl">{cost === 0 ? "Free" : `${cost}`}</h5>
              <span className="flex justify-end">
                {rating &&
                  new Array(rating).fill(0).map((item, index) => (
                    <span key={index} className="text-yellow-400 text-2xl">
                      <StarIcon />
                    </span>
                  ))}
              </span>
            </div>
          ) : (
            <>
              <div className="h-5 mb-2 w-full rounded-md ab gradient-loader"></div>
              <div className="h-5 w-full rounded-md ab gradient-loader"></div>
            </>
          )}
        </div>
        <span className="flex gap-3 mt-10 flex-wrap md:flex-nowrap max-w-full overflow-hidden relative">
          {tags !== undefined &&
            tags.map(
              (tag, index) =>
                index < 2 && (
                  <TagButton
                    key={tag}
                    tag={tag}
                    handleClick={(tag) => {
                      history.push(`/courses?tags[in]=${tag}`);
                      dispatch(getCoursesAsync(`/courses?tags[in]=${tag}`));
                    }}
                  />
                )
            )}

          {tags !== undefined && tags.length > 2 && (
            <div className="tag-3 py-1 px-4 bg-indigo-200 text-xs rounded-full">
              + {tags.length - 2}
            </div>
          )}
          {tags === undefined && (
            <div className="h-5 w-full rounded-md ab gradient-loader"></div>
          )}
        </span>
      </div>
    </div>
  );
};

export default ListItem;
